/**
 * Retrieves a specified token from the local storage.
 * @param keyPrefix The prefix used by Cognito in local storage.
 * @param userName The username for which the token is stored.
 * @param tokenType The type of token to retrieve ("accessToken", "idToken", "refreshToken").
 * @returns The token as a string or null if the token does not exist.
 * 
 * @example 
 * const { username, userId, signInDetails } = await getCurrentUser();
 * const COGNITO_KEY_PREFIX = `CognitoIdentityServiceProvider.${process.env.REACT_APP_CLIENT_ID}`;
 * this.api_token = getTokenFromLocalStorage(COGNITO_KEY_PREFIX, username, 'accessToken')
 */
export function getTokenFromLocalStorage(keyPrefix: string, userName: string, tokenType: 'accessToken' | 'idToken' | 'refreshToken'): string | null {
    // Construct the key used to store the token in local storage
    const tokenKey = `${keyPrefix}.${userName}.${tokenType}`;
    // Retrieve the token from local storage
    const token = localStorage.getItem(tokenKey);
    return token;
}